<template>
	<v-col class="background">
		<v-row>
			<v-col cols="4" class="d-flex">
				<v-img contain height="180" :src="logo" alt="logo" />
			</v-col>
			<v-col cols="4" class="d-flex justify-center align-center big">
				<div class="d-flex"> Winning Numbers </div>
			</v-col>
			<v-col cols="4" class="d-flex" align-self="center">
				<v-img contain height="200" :src="logo" alt="logo" />
			</v-col>
		</v-row>
		<v-row
			v-for="number in result.numbers"
			:key="number.playType.id"
			no-gutters
		>
			<v-col cols="4" align-self="center">
				<v-img
					:src="imageForPlayType(number.playType)"
					contain
					height="70"
					alt="playType"
				/>
			</v-col>
			<v-col cols="8">
				<v-img
					v-for="(result, index) in number.digits"
					width="100"
					contain
					class="d-inline-block"
					:key="index"
					:src="fieryBalls[parseInt(result, 10)]"
					alt="result"
				/>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
import ResultField from '../../../../enumerations/ResultField.json';
import logo from './images/logo.png';
import logoWhite from './images/logo.png';
import fiery0 from './images/0.png';
import fiery1 from './images/1.png';
import fiery2 from './images/2.png';
import fiery3 from './images/3.png';
import fiery4 from './images/4.png';
import fiery5 from './images/5.png';
import fiery6 from './images/6.png';
import fiery7 from './images/7.png';
import fiery8 from './images/8.png';
import fiery9 from './images/9.png';

import pick2 from './images/pick2.png';
import pick3 from './images/pick3.png';
import pick4 from './images/pick4.png';
import pick5 from './images/pick5.png';

export default {
	name: 'WinningNumbers',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			logo,
			logoWhite,
			fieryBalls: [
				fiery0,
				fiery1,
				fiery2,
				fiery3,
				fiery4,
				fiery5,
				fiery6,
				fiery7,
				fiery8,
				fiery9
			]
		};
	},
	mounted() {
		this.$confetti.start();
	},
	destroyed() {
		this.$confetti.stop();
	},
	methods: {
		imageForPlayType(playType) {
			switch (playType.id) {
				case ResultField.PickTwo:
					return pick2;
				case ResultField.CashThree:
					return pick3;
				case ResultField.PickFour:
					return pick4;
				case ResultField.PickFive:
					return pick5;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
img {
	max-height: 130px;
}

.big {
	font-size: 2.5em;
	color: white;
}

img.lucky-logo {
	max-height: 100px;
}

img.winning-numbers {
	max-height: 200px;
}
</style>
